import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, ShieldAlert } from "lucide-react";

export function OverridesTile() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/pipeline/overrides").then(({ data }) => setItems(data)).catch(() => setItems([])); }, []);
  return (
    <div className="bg-white border border-slate-200 rounded-xl p-5 lg:col-span-3" data-testid="overrides-tile">
      <div className="flex items-center gap-2 text-sm font-semibold text-slate-800"><ShieldAlert className="w-4 h-4 text-rose-600" /> Sign-off overrides by Super Admin</div>
      {items === null ? <div className="text-sm text-slate-400 mt-3">Loading…</div> : items.length === 0 ? (
        <div className="text-sm text-slate-500 mt-3" data-testid="overrides-empty">No overrides issued.</div>
      ) : (
        <ul className="mt-3 divide-y divide-slate-100">{items.map((o, i) => (
          <li key={i} className="py-2.5 text-sm" data-testid={`override-item-${i}`}>
            <Link to={`/candidates/${o.candidate_id}`} className="font-medium text-slate-900 hover:underline">{o.candidate_name}</Link>
            <span className="text-slate-600"> — {o.reason}</span>
            <div className="text-xs text-slate-400">{new Date(o.at).toLocaleString()} · {o.by_name}</div>
          </li>
        ))}</ul>
      )}
    </div>
  );
}
import { api } from "@/api/client";
import { StageBadge } from "@/lib/pipeline";

export function PendingBanner({ c }) {
  if (!c.pending_groups?.length) return null;
  return (
    <div className="flex items-start gap-2 bg-red-50 border border-red-300 text-red-800 rounded-lg px-4 py-3 text-sm" data-testid="candidate-pending-alert">
      <AlertTriangle className="w-4 h-4 mt-0.5 shrink-0" />
      <span>Stage <b>{c.current_stage}</b> is waiting on: {c.pending_groups.join(", ")}.</span>
    </div>
  );
}

export function PipelineAlertsPanel() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/pipeline/alerts").then(({ data }) => setItems(data)).catch(() => setItems([])); }, []);
  if (!items) return null;
  return (
    <div className="lg:col-span-3 bg-white rounded-xl border border-red-200 overflow-hidden" data-testid="pipeline-alerts-panel">
      <div className="px-5 py-3 bg-red-50 border-b border-red-200 flex items-center gap-2 text-sm font-semibold text-red-800">
        <AlertTriangle className="w-4 h-4" /> Checklist alerts ({items.length})
      </div>
      {items.length === 0 ? <div className="px-5 py-4 text-sm text-emerald-700" data-testid="pipeline-alerts-empty">All candidates are on track.</div> : (
        <ul>{items.map((c) => (
          <li key={c.id} className="flex flex-wrap items-center justify-between gap-2 px-5 py-2.5 border-t border-slate-100 first:border-t-0" data-testid={`pipeline-alert-${c.id}`}>
            <span><Link to={`/candidates/${c.id}`} className="font-medium text-red-700 hover:underline">{c.full_name}</Link> <span className="text-xs text-slate-400 ml-1">{c.rank}</span></span>
            <span className="flex items-center gap-2 text-xs text-slate-600"><StageBadge stage={c.current_stage} /> waiting on {c.pending_groups.join(", ")}</span>
          </li>
        ))}</ul>
      )}
    </div>
  );
}
